"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_check_circle_fill_style_1 = __importDefault(require("./uicon.check.circle.fill.style"));
class UiconCheckCircleFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M16,0c8.831,0 16,7.169 16,16c0,8.831 -7.169,16 -16,16c-8.831,0 -16,-7.169 -16,-16c0,-8.831 7.169,-16 16,-16Zm-2.349,21.47l0.012,0.048c0.207,-0.011 0.404,-0.097 0.554,-0.241l9.156,-9.361l-1.12,-1.097l-8.602,8.795l-3.916,-3.951l-1.108,1.096l4.469,4.482c0.148,0.146 0.347,0.228 0.555,0.229Z" }, void 0) }), void 0));
        };
    }
}
UiconCheckCircleFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconCheckCircleFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_check_circle_fill_style_1.default)(UiconCheckCircleFill);
//# sourceMappingURL=uicon.check.circle.fill.js.map